import type Stripe from 'stripe';

export const getStripeInvoices = async (
  stripeCustomerId: string,
  params: Stripe.InvoiceListParams
) => {
  return await $fetch<{
    data: Stripe.Response<Stripe.Invoice[]> | null;
    error: any;
  }>(`/api/stripe/customer/${stripeCustomerId}/invoices`, {
    method: 'GET',
    params,
  });
};
